import { AlertError, AlertSuccess,HasError } from 'vform'
import Vue from 'vue'

import Button from './Button'
import Card from './Card'
import Checkbox from './Checkbox'
import Child from './Child';

// Components that are registered globaly.
[Card, Child, Button, Checkbox, HasError, AlertError, AlertSuccess].forEach((Component) => {
  Vue.component(Component.name, Component)
})
